// extracted by mini-css-extract-plugin
export default {"space":"space__3WmKC"};